import React, {useState} from "react";

export const EditTodoForm = ({editTodo, task}) => {
    const [value, setValue] = useState(task.task);

    const handleSubmit = (e) => {
        e.preventDefault();

        if (value){
            //edit todo
            editTodo(value, task.id);
            // clear form after submission
            setValue('');
        }
    }

    return(
        <form onSubmit={handleSubmit} className="TodoForm">
            <input type="text" value={value} onChange = {(e) => setValue(e.target.value)} className="todo-input" placeholder="update task"></input>
            <button type="submit" className="todo-btn">update task</button>

        </form>
    );
}